import React from 'react';
import { DefaultToast } from 'react-toast-notifications';

const CustomToast = ({ children, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <DefaultToast {...props}>{children}</DefaultToast>
);
export default CustomToast;
